/** Query keys in one place, so invalidation after a mutation cannot miss a cache. */
export const queryKeys = {
  me: ['me'] as const,
  consent: ['privacy', 'consent'] as const,
  vehicles: ['vehicles'] as const,
  devices: ['devices'] as const,
  deviceStatus: ['devices', 'status'] as const,
  device: (id: number) => ['devices', id] as const,
  /** Under the 'devices' prefix on purpose: invalidating queryKeys.devices after a
   *  lifecycle action refreshes the admin registry too. */
  devicesAdmin: (state?: string, q?: string) => ['devices', 'admin', state ?? '', q ?? ''] as const,
  users: ['users'] as const,
  adminStats: ['admin', 'stats'] as const,
  customers: (q?: string) => ['admin', 'customers', q ?? ''] as const,
  customer: (id: number) => ['admin', 'customers', id] as const,
  telemetry: (id: number, limit: number) => ['telemetry', id, limit] as const,
  summary: ['dashboard', 'summary'] as const,
  crashes: (limit: number) => ['dashboard', 'crashes', limit] as const,
  activeCrashes: ['crash', 'active'] as const,
  alerts: (limit: number) => ['alerts', limit] as const,
};

/** Polling intervals. Paused on hidden tabs by the shared query defaults. */
export const POLL = {
  /** Fleet map — many devices, a heavier query on the backend (N+1 per device). */
  fleetStatus: 15_000,
  /** A single owner's devices on the overview. */
  ownerStatus: 30_000,
  summary: 60_000,
  alerts: 30_000,
  /** While waiting for a re-dispatch that returned 202 to resolve. */
  resendPending: 3_000,
  /** The active-crash banner counts down a 45 s window — poll it briskly. */
  activeCrash: 3_000,
} as const;
